// extracted by mini-css-extract-plugin
module.exports = {"vGutter":"8px","item":"CardItem_item__agqZt","item_link":"CardItem_item_link__13PeB"};